export class RolePermissionModel
{
     id:number;
     roleId:number; 
     permissionId:number;
}